import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { UseCampaignsParams } from "./campaigns.types";
import { campaignQueryKeys } from "./queryKeys";

import { instance } from "@/lib/axios/instance";
import { CampaignTypeDTO } from "@/types/response/CampaignType";
import { PagedResponse } from "@/types/response/PagedResponse";

export function useCampaigns(params: UseCampaignsParams) {
  return useQuery<PagedResponse<CampaignTypeDTO>, AxiosError>({
    queryKey: campaignQueryKeys.list(params),
    queryFn: () =>
      instance
        .get<PagedResponse<CampaignTypeDTO>>("/api/v2/Campaigns", {
          params: {
            descending: params.descending,
            orderBy: params.orderBy,
            page: params.page,
            pageSize: params.pageSize,
            clientId: params.clientId,
            search: params.search,
            statuses:
              params.statuses && params.statuses.length > 0
                ? params.statuses
                : undefined,
            includeIntegrations: params.includeIntegrations ?? false,
            activeFrom: params.activeFrom,
            activeTo: params.activeTo,
          },
        })
        .then((res) => res.data),
    placeholderData: keepPreviousData,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
